export const RESOLUTION = ["低画質", "標準", "高画質"];

export const Bitrate: string[] = ["700000", "1000000", "3000000"];

export const Resolution: string[] = ["720×480", "1280×720", "1920×1080"];

export const FrameRate: string[] = ["15", "30", "30"];

export interface UpdateVideoInfo {
    id: number;
    bitrate: number;
    width: number;
    height: number;
    framerate: number;
    denoise: boolean;
    opTemplateId: number;
    edTemplateId: number;
    userId: number;
}

export interface ExportVideoInfo {
    id: number;
    bitrate: number;
    width: number;
    height: number;
    framerate: number;
    denoise: boolean;
    status: string;
    opTemplateId: number;
    edTemplateId: number;
}
